/**
 * The server's 400 problems (`ModelQueryValidator`), in plain words.
 *
 * Each problem names its key, `query.tags.all[0]: must be a tag (…)`. The
 * key becomes the filter's everyday name and the rest is kept, since the
 * validator already writes it as a short sentence. An unknown key keeps
 * the problem as sent rather than guessing.
 */
const NAMES: [RegExp, string][] = [
  [/^query\.text$/, 'Search text'],
  [/^query\.tags\.all(\[\d+\])?$/, 'Tags'],
  [/^query\.tags\.any(\[\d+\])?$/, 'Either-or tags'],
  [/^query\.tags\.none(\[\d+\])?$/, 'Excluded tags'],
  [/^query\.tags(\..*)?$/, 'Tags'],
  [/^query\.authors(\[\d+\])?$/, 'Author'],
  [/^query\.updated(\..*)?$/, 'Updated'],
  [/^query\.created(\..*)?$/, 'Created'],
  [/^query\.editorsPick$/, "Editor's picks"],
  [/^query\.shared$/, 'Shared with'],
  [/^query\.usesFunctional$/, 'Uses functional'],
  [/^query\.functionals(\[\d+\])*$/, 'Uses functionals'],
  [/^query\.submodels(\[\d+\])*$/, 'Uses submodels'],
  [/^query\.sort$/, 'Sort'],
  [/^(skip|limit)$/, 'Paging'],
  [/^body$/, 'Search'],
];

export function explainProblem(problem: string): string {
  const at = problem.indexOf(': ');
  if (at < 0) return problem;
  const key = problem.slice(0, at);
  const rest = problem.slice(at + 2);
  const name = NAMES.find(([re]) => re.test(key))?.[1];
  if (!name) return problem;
  return `${name}: ${rest}`;
}

export function explainProblems(problems: string[]): string[] {
  const out = problems.map(explainProblem);
  return out.length ? out : ['The search was refused. Check the filters and try again.'];
}
